<template>
  <v-container>
    <v-row v-if="userBillings">
      <v-col cols="12">
        <v-card
        elevation="0">
          <v-row>
            <v-col>
              <span class="block mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Payments</span>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col>
              <span v-if="nextPayment != null"><strong>Next payment</strong> {{new Intl.NumberFormat('en', {style: 'currency', currency:nextPayment.currency}).formatToParts("1").find(part=>part.type="currency").value}}{{nextPayment.amount}} <strong>due on</strong> {{nextPayment.date}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="creditDetailHeaders"
                :items="userBillings.receipts"
                class="elevation-1"
              >
                <template v-slot:item.amount="{item}">
                  <span class="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">{{new Intl.NumberFormat('en', {style: 'currency', currency:item.currency}).formatToParts("1").find(part=>part.type="currency").value}}{{item.amount}}</span>
                </template>

                <template v-slot:item.tax="{item}">
                  <span class="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">{{new Intl.NumberFormat('en', {style: 'currency', currency:item.currency}).formatToParts("1").find(part=>part.type="currency").value}}{{item.tax}}</span>
                </template>

                <template v-slot:item.currency="{item}">
                  <span class="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">{{item.currency}}</span>
                </template>

                <template v-slot:item.receipt_url="{item}">
                  <span class="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white"><a :href="item.receipt_url" target="_blank"><v-btn class="blue white--text" text>Receipt</v-btn></a></span>
                </template>

                <template v-slot:item.created_at="{item}">
                  <span class="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">{{ item.created_at | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY, h:mm:ss a')}}</span>
                </template>

                <template v-slot:item.paid_at="{item}">
                  <span class="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">{{ item.paid_at | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY, h:mm:ss a')}}</span>
                </template>

              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import SubscriptionService from '../../services/subscription.service';

  export default {
    name: 'Billings',

    components: {
      
    },

    data(){
      return {
        userBillings: null,
        userLastNextPayments: null,
        nextPayment: null,
        creditDetailHeaders: [
          { text: 'Amount', value: 'amount' },
          { text: 'Tax', value: 'tax' },
          { text: 'Currency', value: 'currency' },
          { text: 'Paid At', value: 'paid_at' },
          { text: 'Created At', value: 'created_at' },
          { text: 'Action', value: 'receipt_url' },
        ]
      }
    },

    created(){
      this.base = 'http://localhost:8000';
      
      this.init();
    },

    methods: {
      init(){
        this.loadFromStorage();
        this.getUserBillings();
        this.getUserLastNextPayments();
      },

      loadFromStorage() {
        try {
          this.userBillings = JSON.parse(localStorage.getItem('userBillings'));
        } catch(e) {
          localStorage.removeItem('userBillings');
        }

        try {
          this.userLastNextPayments = JSON.parse(localStorage.getItem('userLastNextPayments'));
          this.nextPayment = this.userLastNextPayments.nextPayment;
        } catch(e) {
          localStorage.removeItem('userLastNextPayments');
        }
      },

      getUserBillings(){
        SubscriptionService.getUserBillings().then(
          response => {
            this.userBillings = response.data.response;

            this.userBillingsList = JSON.stringify(this.userBillings);
            localStorage.setItem('userBillings', this.userBillingsList);
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
      },

      getUserLastNextPayments(){
        SubscriptionService.getUserLastNextPayments().then(
          response => {
            if(JSON.stringify(this.userLastNextPayments) !== JSON.stringify(response.data.response))
            {
              this.userLastNextPayments = response.data.response;
              this.nextPayment = this.userLastNextPayments.nextPayment;

              this.userLastNextPaymentsList = JSON.stringify(this.userLastNextPayments);
              localStorage.setItem('userLastNextPayments', this.userLastNextPaymentsList);
            }
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
      },

      
    }
  }
</script>